export enum NotificationTemplates {
  WishList = 'wishlist',
  Compare = 'compare',
}
